import { Alert, Box, Grid, Typography } from "@mui/material";
import React, {
  Fragment,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import CustomButton from "../../components/Form/CustomButton";
import { CustomInput } from "../../components/Form/CustomInputField";
import { AuthContext } from "../../context/auth-context";
import { signInUser } from "../../firebase/firebaseAuth";
import { ToastContainer, toast } from "react-toastify";
import { useCart } from "../../context/cart-context";

const SignUpPage = () => {
  let navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from || "/dashboard";
  const errRef = useRef();
  const [errMsg, setErrMsg] = useState("");

  const { setIsLoading } = useCart();

  const [userEmail, setUserEmail] = useState("");
  const [role, setRole] = useState("user");
  const [userPassword, setUserPassword] = useState("");

  const { isAuthenticated, userUID, loginUser } = React.useContext(AuthContext);

  const handleSubmit = async (e) => {
    // prevent the form from refreshing the whole page

    setErrMsg("");

    function validateEmail(email) {
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }

    if (validateEmail(userEmail) !== true) {
      setErrMsg("Please input a valid email address");
    } else if (userPassword === "") {
      setErrMsg("Please input a valid password");
    } else {
      setIsLoading(true);

      try {
        const user = await signInUser(userEmail, userPassword);
        // console.log("User signed in:", user);
        loginUser(
          user.uid,
          user.email,
          user.firstname,
          user.lastname,
          user.role
        );
        userUID(user.uid);
        // toast(`Welcome: ${user.firstname}!`, {
        //   type: "success",
        // });
        setIsLoading(false);

        // setTimeout(() => {
        //   navigate("/dashboard");
        // }, 6000);
        // Do something with the signed-in user and user details
      } catch (error) {
        setIsLoading(false);

        setErrMsg("Error signing in user");
        console.error("Error signing in user:", error);
      }
    }
  };

  React.useEffect(() => {
    if (isAuthenticated) {
      navigate(from, { replace: true });
    }
  }, [isAuthenticated]);

  return (
    <Fragment>
      <Grid container spacing={0} item={true}>
        <Grid xs={0} sm={6} md={7} item={true}>
          <div className="h-screen relative hidden md:flex items-center justify-center self-center">
            <img
              src="SBD/salon1.jpg"
              alt=""
              className="w-5/6 md:w-full md:py-0 py-48 object-cover h-full"
            />
            {/* <WomanIcon /> */}
          </div>
        </Grid>
        <Grid xs={12} sm={6} md={5} item={true}>
          <div className="bg-gray-50 h-full md:py-52 py-10 ">
            {/* Error Message */}
            {errMsg !== "" ? (
              <Box className="px-3 md:px-12">
                <Alert
                  severity="error"
                  onClose={() => {
                    setErrMsg("");
                  }}
                  className=" "
                >
                  {errMsg}
                </Alert>
              </Box>
            ) : null}
            {/* Error Ends */}
            <Box as="div" className="w-3/4 mx-auto">
              <ToastContainer />

              <Typography
                variant="h3"
                fontWeight={400}
                fontSize={{ xs: "25px", sm: "30px", md: "30px" }}
                lineHeight={{ xs: "103%", sm: "105.5%" }}
                letterSpacing={"-0.01em"}
                color="primary"
                className=" text-center py-4 capitalize"
              >
                Log in
              </Typography>

              <Grid container spacing={2} item={true} className="">
                <Grid xs={12} sm={12} md={12} item={true}>
                  <div className="mb-6 text-center">
                    <CustomInput
                      label="Email"
                      type="email"
                      className="w-full"
                      onChange={(e) => {
                        setUserEmail(e.target.value);
                        setErrMsg("");
                      }}
                      value={userEmail}
                      required
                    />
                  </div>
                </Grid>

                <Grid xs={12} sm={12} md={12} item={true}>
                  <div className="mb-6 text-center">
                    <CustomInput
                      label="Password"
                      type="password"
                      className="w-full"
                      onChange={(e) => {
                        setUserPassword(e.target.value);
                        setErrMsg("");
                      }}
                      value={userPassword}
                      required
                    />
                  </div>
                </Grid>
              </Grid>

              <Box className="text-end mb-3">
                <Typography
                  variant="body"
                  fontSize={{ xs: "12px", sm: "12px", md: "12px" }}
                  lineHeight={{ xs: "185%", sm: "180%" }}
                  letterSpacing={"-0.02em"}
                  color={"secondary"}
                >
                  <Link className="text-red-500  underline" to={"/signup"}>
                    Create Account
                  </Link>
                </Typography>
              </Box>

              <div className="text-center mx-auto">
                <CustomButton
                  type="submit"
                  // form="add-member-form"
                  //   loading={true}
                  sx={{ width: "150px", height: "55px" }}
                  color="secondary"
                  className="text-sm !uppercase"
                  onClick={handleSubmit}
                  // to={"/checkout"}
                  // fullWidth
                >
                  Log in
                </CustomButton>
              </div>
            </Box>
          </div>
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default SignUpPage;
